<template>
  <div
    class="calendar-picker px-3 py-3 overflow-hidden"
    :class="{'d-none': appointmentList.length === 0}"
    :style="`height: calc(100vh - ${calendarPickerHeight} + ${scrollTop}px)`"
  >
    <template v-if="!loadingAppointment">
      <div class="d-flex justify-content-between">
        <span class="font-rubik-medium text-lg text-grey-netral">Praktik Online</span>
        <p class="text-lg mb-2">
          <img src="@/assets/icon/icon-calendar.svg" alt="">
          <span v-if="$parent.$parent.txtDatePicker" class="font-rubik-medium text-blue-darker">{{ $moment(`${$parent.$parent.txtDatePicker}`, 'YYYY, MM, DD').format('MMMM YYYY') }}</span>
        </p>
      </div>
      <div>
        <div class="d-flex justify-content-around mx-n3">
          <span v-for="(day, index) in 7" :key="index" class="text-grey-netral">
            {{ $moment().isoWeekday(index).format('ddd') }}
          </span>
        </div>
        <div class="select-day-info">
          <client-only>
            <carousel :navigate-to="calendarIndex" :pagination-enabled="false" :scroll-per-page="true" :per-page-custom="[[1, 7]]" @page-change="changeWeek">
              <slide
                v-for="(list, index) in calendar.date"
                :key="index"
              >
                <b-button
                  v-scroll-to="{
                    el: `#yd${list}`,
                    container: '#nav-scroller',
                    offset: 0,
                    duration: 700,
                    onStart: onStartScroll,
                    onDone: onDoneScroll,
                    cancelable: false,
                  }"
                  class="date"
                  :class="checkCalendarDate(list)"
                  @click="setCalendarDate(list)"
                >
                  {{ $moment.unix(list).format('DD') }}
                </b-button>
              </slide>
            </carousel>
          </client-only>
        </div>
        <div class="box-duration">
          <div class="durations">
            <span class="font-rubik-medium">Durasi: <em>{{ (duration === '-' && !dataSelect) ? `-` : (duration === '-' && dataSelect) ? `${dataSelect.durationConversation / 60} Menit` : `${conversation / 60} Menit` }}</em></span>
            <span class="font-rubik-medium">Rp: <em>{{ (price === '-' && !dataSelect) ? `-` : (price === '-' && dataSelect) ? $numberFormat(dataSelect.priceSelect) : $numberFormat(price) }}</em></span>
          </div>
        </div>
        <!--    Content Appointment-->
        <content-appointment
          ref="contentAppointment"
          :calendar="calendar"
          :result="result"
        />
      </div>
    </template>
    <template v-else>
      <div class="text-center mt-5">
        <b-spinner label="Spinner" />
      </div>
    </template>
  </div>
</template>

<script>
import ContentAppointment from '@/components/appointment-component/ContentAppointment'
import _ from 'lodash'
export default {
  name: 'CalendarPicker',
  components: {
    ContentAppointment
  },
  props: {
    dataSelect: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    scheduleAvailable: false,
    calendar: {
      date: [],
      hour: null,
      selectedDate: null
    },
    loadingAppointment: false,
    result: [],
    rangeFromNow: null,
    appointmentsData: null,
    totalConsult: null,
    epochToday: null,
    selectedDay: null,
    timestampStart: null,
    timestampEnd: null,
    pickDate: null,
    nearestTodayId: null,
    nearestToday: null,
    nearIndex: 0,
    countIndex: 0,
    calendarIndex: 0,
    calendarNearIndex: 0,
    calendarParamsIndex: 0,
    dateMonthFromNow: null,
    appointmentList: [],
    appointmentFiltered: [],
    timeSelected: [],
    timeObject: [],
    refDayContainer: [],
    duration: '-',
    price: '-',
    conversation: '-',
    review: '-',
    isActive: false
  }),
  computed: {
    scrollTop () {
      return this.$store.state.doctor.scrollTop
    },
    profileDoctorHeight () {
      return this.$parent.profileDoctorHeight
    },
    calendarPickerHeight () {
      return this.profileDoctorHeight > 154 ? '317px' : this.profileDoctorHeight > 130 ? '300px' : '317px'
    },
    checkCountdown () {
      return this.$store.state.doctor.countdownOff
    }
  },
  watch: {
    checkCountdown: {
      handler (value) {
        if (value) {
          this.fetchScheduleNearest()
        }
      }
    }
  },
  mounted () {
    this.fetchScheduleNearest()
    if (this.$parent.$parent.doctorProfile.Appointments) {
      this.conversation = this.$parent.$parent.doctorProfile.Appointments.ConversationTime
      this.review = this.$parent.$parent.doctorProfile.Appointments.ReviewTime
    }
    // reset saldo yesdok and promo
    this.$store.commit('doctor/SET_USE_YESDOK_BALANCE', null)
    this.$store.commit('doctor/SET_PROMO_USED', null)
  },
  methods: {
    fetchSelectedAppointment () {
      const appointment = this.$store.state.doctor.doctorData.Appointments.find(o => o.PublicID === localStorage.getItem('public_id'))
      this.$store.commit('doctor/SET_BOOKING_APPOINTMENT', appointment)
    },
    scheduleCheck () {
      const today = this.$moment().startOf('day').unix()
      let rangeStart = this.nearestToday
      this.loadingAppointment = true
      this.$parent.loadingAppointment = true
      if (!this.nearestToday) {
        rangeStart = Math.floor(today / 1000)
      }

      this.rangeFromNow = this.$moment.unix(rangeStart).add(1, 'months').endOf('days').unix()

      let clinicName = null
      if (this.$route.params.clinicName) {
        clinicName = this.$route.params.clinicName
      }
      this.$store.dispatch('doctor/check', {
        did: this.$route.params.doctorNickName,
        clinicName,
        timestampStart: this.selectedDay || rangeStart,
        timestampEnd: this.rangeFromNow
      })
        .then((res) => {
          const result = []
          this.$nuxt.$emit('appointmentList', this.$store.state.doctor.doctorData.Appointments)
          this.$store.state.doctor.doctorData.Appointments.map((obj) => {
            const data = []
            const dataFree = []
            const dataHospital = []
            obj.StartDay = this.$moment.unix(obj.Start).startOf('days').unix()
            if (obj.Price === 25000 && !obj.IsExercise) {
              dataFree.push(obj)
            } else if (!obj.ClinicID) {
              data.push(obj)
            } else {
              dataHospital.push(obj)
            }
            if (result.length === 0) {
              const object = {
                startDay: obj.StartDay,
                data,
                dataFree,
                dataHospital
              }
              result.push(object)
            } else {
              let same = 0
              result.map((objectData) => {
                if (objectData.startDay === obj.StartDay) {
                  same = 1
                  if (obj.Price === 25000 && !obj.IsExercise) {
                    objectData.dataFree.push(obj)
                  } else if (!obj.ClinicID) {
                    objectData.data.push(obj)
                  } else {
                    objectData.dataHospital.push(obj)
                  }
                }
              })
              if (same === 0) {
                const object = {
                  startDay: obj.StartDay,
                  data,
                  dataFree,
                  dataHospital
                }
                result.push(object)
              }
            }
          })

          result.map((obj, index) => {
            const scheduleFreeHospital = obj.dataFree.filter(obj => obj.ClinicID !== null)
            const scheduleFreeSelf = obj.dataFree.filter(obj => !obj.ClinicID)
            const group = _.groupBy(obj.dataHospital, 'ClinicID')
            const groupFree = _.groupBy(scheduleFreeHospital, 'ClinicID')
            obj.dataHospital = []
            obj.dataFree = []
            for (const property in group) {
              obj.dataHospital.push(group[property])
            }
            for (const property in groupFree) {
              obj.dataFree.push(groupFree[property])
            }
            // push scheduleFreeSelf to first index
            if (scheduleFreeSelf.length > 0) {
              obj.dataFree.unshift(scheduleFreeSelf)
            }
          })
          this.epochToday = this.$moment().startOf('days').unix()
          this.dateMonthFromNow = this.$moment().add(1, 'months').endOf('day').unix()
          this.result = result
          if (res.Data && res.Data.Doctor) {
            this.totalConsult = res.Data.Doctor.TotalConsult
          }
          const appointments = this.$store.state.doctor.doctorData.Appointments
          if (!this.pickDate) {
            this.getData(appointments)
          }

          if (Object.keys(appointments).length > 0) {
            this.appointmentsData = _.find(appointments, { Status: 'AVAILABLE' })
          }
          this.fetchCalendarDate(this.nearestToday)
          if (this.appointmentsData) {
            const dataOnline = this.appointmentsData
            this.nearestToday = dataOnline.Start
            this.$parent.nearestToday = this.nearestToday
            this.$parent.$parent.lblConsultPrice = dataOnline.Price
            this.nearestTodayId = dataOnline.PublicID
            this.$parent.$parent.txtDatePicker = this.pickDate || this.$moment.unix(today).format('YYYY, MM, DD')
            this.$parent.$parent.lblDateSelected = this.$moment.unix(dataOnline.Start).format('dddd, DD MMMM yyyy')
            this.$parent.$parent.lblTimeSelected = this.$moment.unix(dataOnline.Start).format('HH:mm') + ' - ' + this.$moment.unix(dataOnline.End).format('HH:mm')
            if (this.$store.state.doctor.stepComponent === 'initial') {
              this.gotoNearest()
            } else if (this.$store.state.doctor.stepComponent === 'confirmation' || this.$store.state.doctor.stepComponent === 'list-payments') {
              this.setSelectedDate(this.$store.state.doctor.booking.selectedAppointment.StartDay)
            }
          } else {
            this.loadingAppointment = false
            this.$parent.loadingAppointment = false
            this.$parent.$refs.modalNoAppointment.show()
          }
          this.loadingAppointment = false
          this.$parent.loadingAppointment = false
        })
        .catch((error) => {
          this.loadingAppointment = false
          this.$parent.loadingAppointment = false
          throw new Error(error)
        })
    },
    fetchScheduleNearest () {
      if (this.$parent.$parent.doctorProfile) {
        this.scheduleAvailable = true
        const dataDoctorProfile = this.$parent.$parent.doctorProfile
        if (dataDoctorProfile.Appointments && dataDoctorProfile.Appointments.Online && typeof dataDoctorProfile.Appointments.Online.Start !== 'undefined') {
          this.timestampStart = dataDoctorProfile.Appointments.Online.Start - parseInt(dataDoctorProfile.Doctor.BookTime)
          this.timestampEnd = this.getEpochEOD(this.timestampStart) - parseInt(dataDoctorProfile.Doctor.BookTime)
        }
        if (dataDoctorProfile.Appointments && dataDoctorProfile.Appointments.Start) {
          this.nearestToday = dataDoctorProfile.Appointments.Start
        }
        this.scheduleCheck()
      } else {
        this.scheduleAvailable = false
      }
    },
    fetchCalendarDate (val) {
      const near = this.$moment.unix(val).startOf('day').valueOf() / 1000
      let paramsDate = ''
      let paramsIndex = 0
      const beforeToday = this.getDayBefore()

      const currentMoment = this.$moment().subtract(beforeToday, 'days')
      const endMoment = this.$moment().add(1, 'months').endOf('weeks').endOf('days')

      if (this.$route.query && this.$route.query.date) {
        paramsDate = this.$moment(this.$route.query.date, 'YYYY-MM-DD').startOf('day').valueOf() / 1000
      }

      this.calendar.selectedDate = this.$moment().startOf('day').valueOf()

      while (currentMoment.isBefore(endMoment, 'day')) {
        currentMoment.add(1, 'days')
        const dateCalendar = Math.floor(this.$moment(currentMoment).startOf('day').valueOf() / 1000)

        this.calendar.date.push(dateCalendar)
        if (near !== dateCalendar) {
          this.countIndex += 1
        }
        if (near === dateCalendar) {
          this.nearIndex = this.countIndex
          this.countIndex += 1
        }
        if (paramsDate === dateCalendar) {
          paramsIndex = this.countIndex
          this.countIndex += 1
        }
      }
      this.calendarNearIndex = Math.trunc((this.nearIndex - 0.1) / 7)
      this.calendarParamsIndex = Math.trunc((paramsIndex - 0.1) / 7)
      this.calendarIndex = 0
      this.$parent.calendar = this.calendar
      if (this.$route.query) {
        this.gotoSelectedDate(this.$route.query)
      }
      this.initObserver()
      this.observeSections()
    },
    getData (appointments) {
      const timeSelected = []
      const newObject = []
      if (appointments) {
        appointments.forEach((time, index) => {
          const selectedTime = this.$moment.unix(time.Start).format('MMMM DD YYYY')
          if (!timeSelected.includes(selectedTime)) {
            timeSelected.push(selectedTime)
          }
          const data = time
          data.Time = this.$moment(selectedTime, 'MMMM DD YYYY').format('MM DD YYYY')
          newObject.push(data)
        })
      }
      this.appointmentList = newObject
      this.$parent.appointmentList = this.appointmentList
      this.timeSelected = timeSelected
    },
    initObserver () {
      const options = {
        rootMargin: '0px',
        threshold: [0.99]
      }
      this.observer = new IntersectionObserver((entries) => {
        const active = entries.filter(e => e.isIntersecting)

        if (active.length) {
          this.activeEntry = active[0].target.id
          if (this.allowIntersection) {
            setTimeout(() => {
              this.changeAppointmentDate(this.activeEntry)
            }, 500)
          }
        }
      }, options)
    },
    onShow () {
      this.isActive = !this.isActive
    },
    changeAppointmentDate (val) {
      const selectAppointment = this.$store.state.doctor.doctorData.Appointments.find(o => o.PublicID === this.$parent.$parent.txtTimePicker)
      this.duration = selectAppointment.ConsultLength
      this.conversation = selectAppointment.ConversationTime
      this.review = selectAppointment.ReviewTime
      this.price = selectAppointment.Price
      if (typeof val === 'string') {
        val = val.substring(2)
      }
      val = Number(val)
      const date = this.$moment.unix(val).format('YYYY-MM-DD')
      this.calendar.selectedDate = this.$moment.unix(val).startOf('day').valueOf()
      this.$parent.$parent.txtDatePicker = this.$moment.unix(val).format('YYYY, MM, DD')
      this.handlingParamsDate(date)
      this.calculateDateIndex(val)
    },
    calculateDateIndex (val) {
      let count = 0
      let result

      this.calendar.date.forEach((a) => {
        if (a !== val) {
          count = count + 1
        } else {
          result = Math.trunc((count - 0.1) / 7)
          this.calendarIndex = result
        }
      })
    },
    observeSections () {
      this.$nextTick(() => {
        if (this.$refs.contentAppointment && this.$refs.contentAppointment.$refs.daycontainer) {
          this.$refs.contentAppointment.$refs.daycontainer.forEach((section) => {
            this.observe(section)
          })
        }
      })
    },
    observe (entry) {
      this.observer.observe(entry)
    },
    onStartScroll () {
      this.allowIntersection = false
    },
    onDoneScroll () {
      this.allowIntersection = true
    },
    onDoneScrollNearest () {
      this.gotoNearest()
    },
    scrollToSchedule (date) {
      const element = `#yd${this.$moment.unix(date).startOf('days').unix()}`
      const options = {
        container: '#nav-scroller',
        offset: 0,
        cancelable: false
      }
      this.$scrollTo(element, 700, options)
    },
    setSelectedDate (date) {
      this.$parent.$parent.txtDatePicker = this.$moment.unix(date).format('YYYY, MM, DD')
      this.calendar.selectedDate = this.$moment.unix(date).startOf('day').valueOf()
      setTimeout(() => {
        this.scrollToSchedule(date)
      }, 500)
    },
    gotoNearest () {
      this.calendarIndex = this.calendarNearIndex
      this.$parent.$parent.txtDatePicker = this.$moment.unix(this.nearestToday).format('YYYY, MM, DD')
      // this.$parent.$parent.txtTimePicker = this.nearestTodayId
      this.calendar.selectedDate = this.$moment.unix(this.nearestToday).startOf('day').valueOf()
      setTimeout(() => {
        this.scrollToSchedule(this.nearestToday)
      }, 500)
    },
    gotoSelectedDate (query) {
      if (!query.date) { return }

      const startDay = this.$moment().startOf('day').valueOf()
      const selectedDate = this.$moment(query.date, 'YYYY-MM-DD').valueOf()
      const maxDayDate = Math.floor(this.rangeFromNow * 1000)

      if (selectedDate < startDay || selectedDate > maxDayDate) { return this.handlingParamsDate() }

      if (!this.$moment(query.date, 'YYYY-MM-DD').isValid()) {
        query.date = this.$moment().startOf('day').format('YYYY-MM-DD')
        this.$router.replace({ query: { date: null } })
      }

      this.calendarIndex = this.calendarParamsIndex
      this.$parent.$parent.txtDatePicker = this.$moment(query.date, 'YYYY-MM-DD').format('YYYY, MM, DD')
      this.calendar.selectedDate = this.$moment(query.date, 'YYYY-MM-DD').startOf('day').valueOf()
    },
    getEpochEOD (epoch) {
      return this.$moment.unix(epoch).endOf('day').unix()
    },
    getDayBefore () {
      switch (new Date().getDay()) {
        case 0:
          return 1
        case 1:
          return 2
        case 2:
          return 3
        case 3:
          return 4
        case 4:
          return 5
        case 5:
          return 6
        case 6:
          return 7
        default:
          return 0
      }
    },
    changeWeek (val) {
      this.calendarIndex = val
    },
    checkCalendarDate (val) {
      const today = Math.floor(this.$moment().startOf('day').valueOf() / 1000)
      const list = this.$moment.unix(val).format('DD MM YYYY')
      const date = this.$moment.unix(this.calendar.selectedDate / 1000).format('DD MM YYYY')

      if (list === date) { return 'selected' }
      if (this.$moment.unix(val).format('DD MM YYYY') === this.$moment().startOf('day').format('DD MM YYYY')) { return 'today' }
      if (val < today) { return 'before-date' }
      if (val > this.dateMonthFromNow) { return 'before-date' }
    },
    setCalendarDate (date) {
      const today = Math.floor(this.$moment().startOf('day').valueOf() / 1000)
      if (date < today || date > this.dateMonthFromNow) { return }
      this.handlingParamsDate(this.$moment.unix(date).format('YYYY-MM-DD'))
      this.calendar.selectedDate = date * 1000
      return this.selectSchedule(date * 1000)
    },
    handlingParamsDate (date) {
      const today = this.$moment().startOf('day').format('YYYY-MM-DD')
      if (!date) {
        date = today
      }
      if (this.$route.query.date !== date) { return this.$router.replace({ query: { date } }) }
    },
    selectSchedule (selected) {
      this.selectedDay = this.$moment(selected).unix()
      this.pickDate = this.$moment(selected).format('YYYY, MM, DD')
      this.$parent.$parent.txtDatePicker = this.pickDate
      this.$parent.$parent.timestampEnd = this.getEpochEOD(this.$parent.$parent.timestampStart)

      let appointmentsStore = this.appointmentFiltered
      if (Object.keys(appointmentsStore).length > 0) {
        appointmentsStore = _.find(appointmentsStore, { Status: 'AVAILABLE' })
        if (appointmentsStore) {
          this.$parent.$parent.lblConsultPrice = appointmentsStore.Price
          this.$parent.$parent.txtTimePicker = appointmentsStore.PublicID
          localStorage.setItem('public_id', appointmentsStore.PublicID)
          this.$parent.$parent.txtDatePicker = this.pickDate || this.$moment.unix(appointmentsStore.Start).format('YYYY, MM, DD')
          this.$parent.$parent.lblDateSelected = this.$moment.unix(appointmentsStore.Start).format('dddd, DD MMMM yyyy')
          this.$parent.$parent.lblTimeSelected = this.$moment.unix(appointmentsStore.Start).format('HH:mm') + ' - ' + this.$moment.unix(appointmentsStore.End).format('HH:mm')
        }
      }
    }
  }
}
</script>

<style lang="scss">
 .calendar-picker {
   @media screen and (max-height: 568px) {
     min-height: 460px;
   }
 }
 .calendar-picker {
  .select-day-info {
    margin: 0 -1rem 0px;
  }
 }
 .box-duration {
    position: relative;
    background: #EBFBFF;
    margin: 0 -1rem 1rem;
    padding: 10px 15px 10px 15px;
    border-bottom: 5px solid #F3F2EF;
    .durations {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      .font-rubik-medium {
        color: #11317D;
      }
      span {
        color: #11317D;
        font-size: 18px;
        em {
          color: #00B5E2;
          font-size: 20px;
          font-weight: 500;
          font-style: normal;
          img {
            cursor: pointer;
            margin-top: -2px;
          }
        }
      }
    }
    .box-info {
      top: 42px;
      z-index: 999;
      padding: 15px;
      border-radius: 8px;
      position: absolute;
      background: #00C300;
    }
  }
</style>
